// Countries list with English names (stored in backend) and Spanish translations
export interface Country {
  en: string; // English name - sent to backend
  es: string; // Spanish name - displayed in UI
}

export const COUNTRIES: Country[] = [
  { en: "Afghanistan", es: "Afganistán" },
  { en: "Albania", es: "Albania" },
  { en: "Algeria", es: "Argelia" },
  { en: "Andorra", es: "Andorra" },
  { en: "Angola", es: "Angola" },
  { en: "Antigua and Barbuda", es: "Antigua y Barbuda" },
  { en: "Argentina", es: "Argentina" },
  { en: "Armenia", es: "Armenia" },
  { en: "Australia", es: "Australia" },
  { en: "Austria", es: "Austria" },
  { en: "Azerbaijan", es: "Azerbaiyán" },
  { en: "Bahamas", es: "Bahamas" },
  { en: "Bahrain", es: "Baréin" },
  { en: "Bangladesh", es: "Bangladés" },
  { en: "Barbados", es: "Barbados" },
  { en: "Belarus", es: "Bielorrusia" },
  { en: "Belgium", es: "Bélgica" },
  { en: "Belize", es: "Belice" },
  { en: "Benin", es: "Benín" },
  { en: "Bhutan", es: "Bután" },
  { en: "Bolivia", es: "Bolivia" },
  { en: "Bosnia and Herzegovina", es: "Bosnia y Herzegovina" },
  { en: "Botswana", es: "Botsuana" },
  { en: "Brazil", es: "Brasil" },
  { en: "Brunei", es: "Brunéi" },
  { en: "Bulgaria", es: "Bulgaria" },
  { en: "Burkina Faso", es: "Burkina Faso" },
  { en: "Burundi", es: "Burundi" },
  { en: "Cambodia", es: "Camboya" },
  { en: "Cameroon", es: "Camerún" },
  { en: "Canada", es: "Canadá" },
  { en: "Cape Verde", es: "Cabo Verde" },
  { en: "Central African Republic", es: "República Centroafricana" },
  { en: "Chad", es: "Chad" },
  { en: "Chile", es: "Chile" },
  { en: "China", es: "China" },
  { en: "Colombia", es: "Colombia" },
  { en: "Comoros", es: "Comoras" },
  { en: "Congo", es: "Congo" },
  { en: "Costa Rica", es: "Costa Rica" },
  { en: "Croatia", es: "Croacia" },
  { en: "Cuba", es: "Cuba" },
  { en: "Cyprus", es: "Chipre" },
  { en: "Czech Republic", es: "República Checa" },
  { en: "Denmark", es: "Dinamarca" },
  { en: "Djibouti", es: "Yibuti" },
  { en: "Dominica", es: "Dominica" },
  { en: "Dominican Republic", es: "República Dominicana" },
  { en: "East Timor", es: "Timor Oriental" },
  { en: "Ecuador", es: "Ecuador" },
  { en: "Egypt", es: "Egipto" },
  { en: "El Salvador", es: "El Salvador" },
  { en: "England", es: "Inglaterra" },
  { en: "Equatorial Guinea", es: "Guinea Ecuatorial" },
  { en: "Eritrea", es: "Eritrea" },
  { en: "Estonia", es: "Estonia" },
  { en: "Ethiopia", es: "Etiopía" },
  { en: "Fiji", es: "Fiyi" },
  { en: "Finland", es: "Finlandia" },
  { en: "France", es: "Francia" },
  { en: "Gabon", es: "Gabón" },
  { en: "Gambia", es: "Gambia" },
  { en: "Georgia", es: "Georgia" },
  { en: "Germany", es: "Alemania" },
  { en: "Ghana", es: "Ghana" },
  { en: "Greece", es: "Grecia" },
  { en: "Grenada", es: "Granada" },
  { en: "Guatemala", es: "Guatemala" },
  { en: "Guinea", es: "Guinea" },
  { en: "Guinea-Bissau", es: "Guinea-Bisáu" },
  { en: "Guyana", es: "Guyana" },
  { en: "Haiti", es: "Haití" },
  { en: "Honduras", es: "Honduras" },
  { en: "Hungary", es: "Hungría" },
  { en: "Iceland", es: "Islandia" },
  { en: "India", es: "India" },
  { en: "Indonesia", es: "Indonesia" },
  { en: "Iran", es: "Irán" },
  { en: "Iraq", es: "Irak" },
  { en: "Ireland", es: "Irlanda" },
  { en: "Israel", es: "Israel" },
  { en: "Italy", es: "Italia" },
  { en: "Ivory Coast", es: "Costa de Marfil" },
  { en: "Jamaica", es: "Jamaica" },
  { en: "Japan", es: "Japón" },
  { en: "Jordan", es: "Jordania" },
  { en: "Kazakhstan", es: "Kazajistán" },
  { en: "Kenya", es: "Kenia" },
  { en: "Kiribati", es: "Kiribati" },
  { en: "Kuwait", es: "Kuwait" },
  { en: "Kyrgyzstan", es: "Kirguistán" },
  { en: "Laos", es: "Laos" },
  { en: "Latvia", es: "Letonia" },
  { en: "Lebanon", es: "Líbano" },
  { en: "Lesotho", es: "Lesoto" },
  { en: "Liberia", es: "Liberia" },
  { en: "Libya", es: "Libia" },
  { en: "Liechtenstein", es: "Liechtenstein" },
  { en: "Lithuania", es: "Lituania" },
  { en: "Luxembourg", es: "Luxemburgo" },
  { en: "Macedonia", es: "Macedonia" },
  { en: "Madagascar", es: "Madagascar" },
  { en: "Malawi", es: "Malaui" },
  { en: "Malaysia", es: "Malasia" },
  { en: "Maldives", es: "Maldivas" },
  { en: "Mali", es: "Mali" },
  { en: "Malta", es: "Malta" },
  { en: "Marshall Islands", es: "Islas Marshall" },
  { en: "Mauritania", es: "Mauritania" },
  { en: "Mauritius", es: "Mauricio" },
  { en: "Mexico", es: "México" },
  { en: "Micronesia", es: "Micronesia" },
  { en: "Moldova", es: "Moldavia" },
  { en: "Monaco", es: "Mónaco" },
  { en: "Mongolia", es: "Mongolia" },
  { en: "Montenegro", es: "Montenegro" },
  { en: "Morocco", es: "Marruecos" },
  { en: "Mozambique", es: "Mozambique" },
  { en: "Myanmar", es: "Birmania" },
  { en: "Namibia", es: "Namibia" },
  { en: "Nauru", es: "Nauru" },
  { en: "Nepal", es: "Nepal" },
  { en: "Netherlands", es: "Países Bajos" },
  { en: "New Zealand", es: "Nueva Zelanda" },
  { en: "Nicaragua", es: "Nicaragua" },
  { en: "Niger", es: "Níger" },
  { en: "Nigeria", es: "Nigeria" },
  { en: "North Korea", es: "Corea del Norte" },
  { en: "Northern Ireland", es: "Irlanda del Norte" },
  { en: "Norway", es: "Noruega" },
  { en: "Oman", es: "Omán" },
  { en: "Pakistan", es: "Pakistán" },
  { en: "Palau", es: "Palaos" },
  { en: "Palestine", es: "Palestina" },
  { en: "Panama", es: "Panamá" },
  { en: "Papua New Guinea", es: "Papúa Nueva Guinea" },
  { en: "Paraguay", es: "Paraguay" },
  { en: "Peru", es: "Perú" },
  { en: "Philippines", es: "Filipinas" },
  { en: "Poland", es: "Polonia" },
  { en: "Portugal", es: "Portugal" },
  { en: "Qatar", es: "Catar" },
  { en: "Romania", es: "Rumania" },
  { en: "Russia", es: "Rusia" },
  { en: "Rwanda", es: "Ruanda" },
  { en: "Saint Kitts and Nevis", es: "San Cristóbal y Nieves" },
  { en: "Saint Lucia", es: "Santa Lucía" },
  {
    en: "Saint Vincent and the Grenadines",
    es: "San Vicente y las Granadinas",
  },
  { en: "Samoa", es: "Samoa" },
  { en: "San Marino", es: "San Marino" },
  { en: "Sao Tome and Principe", es: "Santo Tomé y Príncipe" },
  { en: "Saudi Arabia", es: "Arabia Saudita" },
  { en: "Scotland", es: "Escocia" },
  { en: "Senegal", es: "Senegal" },
  { en: "Serbia", es: "Serbia" },
  { en: "Seychelles", es: "Seychelles" },
  { en: "Sierra Leone", es: "Sierra Leona" },
  { en: "Singapore", es: "Singapur" },
  { en: "Slovakia", es: "Eslovaquia" },
  { en: "Slovenia", es: "Eslovenia" },
  { en: "Solomon Islands", es: "Islas Salomón" },
  { en: "Somalia", es: "Somalia" },
  { en: "South Africa", es: "Sudáfrica" },
  { en: "South Korea", es: "Corea del Sur" },
  { en: "South Sudan", es: "Sudán del Sur" },
  { en: "Spain", es: "España" },
  { en: "Sri Lanka", es: "Sri Lanka" },
  { en: "Sudan", es: "Sudán" },
  { en: "Suriname", es: "Surinam" },
  { en: "Swaziland", es: "Suazilandia" },
  { en: "Sweden", es: "Suecia" },
  { en: "Switzerland", es: "Suiza" },
  { en: "Syria", es: "Siria" },
  { en: "Taiwan", es: "Taiwán" },
  { en: "Tajikistan", es: "Tayikistán" },
  { en: "Tanzania", es: "Tanzania" },
  { en: "Thailand", es: "Tailandia" },
  { en: "Togo", es: "Togo" },
  { en: "Tonga", es: "Tonga" },
  { en: "Trinidad and Tobago", es: "Trinidad y Tobago" },
  { en: "Tunisia", es: "Túnez" },
  { en: "Turkey", es: "Turquía" },
  { en: "Turkmenistan", es: "Turkmenistán" },
  { en: "Tuvalu", es: "Tuvalu" },
  { en: "Uganda", es: "Uganda" },
  { en: "Ukraine", es: "Ucrania" },
  { en: "United Arab Emirates", es: "Emiratos Árabes Unidos" },
  { en: "United Kingdom", es: "Reino Unido" },
  { en: "United States", es: "Estados Unidos" },
  { en: "Uruguay", es: "Uruguay" },
  { en: "Uzbekistan", es: "Uzbekistán" },
  { en: "Vanuatu", es: "Vanuatu" },
  { en: "Vatican City", es: "Ciudad del Vaticano" },
  { en: "Venezuela", es: "Venezuela" },
  { en: "Vietnam", es: "Vietnam" },
  { en: "Wales", es: "Gales" },
  { en: "Yemen", es: "Yemen" },
  { en: "Zambia", es: "Zambia" },
  { en: "Zimbabwe", es: "Zimbabue" },
];

// Helper function to get country name in current language
export const getCountryName = (
  englishName: string,
  language: "en" | "es",
): string => {
  const country = COUNTRIES.find((c) => c.en === englishName);
  return country ? country[language] : englishName;
};

// Helper function to get all country names sorted by current language
export const getCountriesSorted = (language: "en" | "es"): Country[] => {
  return [...COUNTRIES].sort((a, b) => a[language].localeCompare(b[language]));
};
